import { TransactionFilterValues } from './types';

export const PAGE_SIZE = 10;

export const SEARCH_DEBOUNCE_MS = 400;

export const STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'TO_APPROVE', label: 'ToSign' },
  { value: 'IN_APPROVAL', label: 'Signing in' },
  { value: 'DECLINED', label: 'Rejecteds' },
  { value: 'IN_PROGRESS', label: 'Processing' },
  { value: 'FAILED', label: 'Not successful' },
];

export const TRANSACTION_TYPE_OPTIONS = [
  { value: 'OWN', label: 'Between own accounts' },
  { value: 'INTERNAL', label: 'Intrabank' },
  { value: 'INTERBANK', label: 'Interbank' },
  { value: 'SWIFT', label: 'International' },
  { value: 'SWIFT_RUB', label: 'Ruble transfer' },
  { value: 'SWIFT_TJS', label: 'International tjs' },
  { value: 'EXCHANGE', label: 'Exchange' },
  { value: 'ASYCUDA', label: 'Custom payments' },
];

export const DISPOSAL_ACCOUNT = '20204972411010100507';

export const cleanFilters = (filters: TransactionFilterValues): TransactionFilterValues =>
  Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const isSameFilters = (a: TransactionFilterValues, b: TransactionFilterValues) => {
  const aKeys = Object.keys(a) as Array<keyof TransactionFilterValues>;
  return aKeys.length === Object.keys(b).length && aKeys.every(key => a[key] === b[key]);
};
